import { render } from "./UpdateMark.vue?vue&type=template&id=08243127"
import script from "./UpdateMark.vue?vue&type=script&lang=js"
export * from "./UpdateMark.vue?vue&type=script&lang=js"

import exportComponent from "../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__